export enum Description {
    ADDRESS = 'Adresse',
    STOP = 'Haltestelle',
    SCHOOL = 'Schule',
    COMPANY = 'Unternehmen',
    DEPOT = 'Betriebshof',
    DRIVER = 'Fahrer:in'
}